import React from 'react';
import { useReveal } from '../../utils/useReveal';

// Wraps children in a scroll-reveal animation.
// direction: 'up' | 'left' | 'right' | 'zoom'
const Reveal = ({ children, direction = 'up', delay = 0, className = '', as = 'div', initial = false }) => {
  const [ref, visible] = useReveal(initial ? { initial } : {});

  const dirClass =
    direction === 'left' ? 'reveal-left'
    : direction === 'right' ? 'reveal-right'
    : direction === 'zoom' ? 'reveal-zoom'
    : '';

  const Tag = as;

  return (
    <Tag
      ref={ref}
      className={`reveal-init ${dirClass} ${visible ? 'reveal-in' : ''} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
